<script>
	import Warning from './../icons/Warning.svelte';
    import { fade } from 'svelte/transition';
    import { notInPreview } from '../store';

    //todo add translations
    let openModal = true;
   
    function rippleClick(e){
        createRipple(e);

        openModal = false;
        setTimeout(() => {
            notInPreview.set(false)
        }, 400);
    }

    function createRipple(event) {

        const button = document.getElementsByClassName('notify-button')[0]
        
        //get start of footer
        const rect = button.getBoundingClientRect();
        const x = event.clientX - rect.left; //x position within the element.
        const y = event.clientY - rect.top;  //y position within the element.

        const circle = document.createElement("span");
       // const diameter = Math.min(button.offsetHeight, button.offsetWidth, 100);
        const diameter = button.clientWidth/8;
        const radius = diameter/2;
        //dia = Math.min(this.offsetHeight, this.offsetWidth, 100), //
        circle.style.width =  `${diameter}px`;
        circle.style.height = `${diameter}px`;
        circle.style.left = x - radius +'px';//`${event.clientX - (button.offsetLeft + radius)}px`;
        circle.style.top = y - radius +'px';//`${event.clientY - (event.offsetY + radius)}px` //`${event.clientY - restHeight - (button.offsetTop + radius)}px`;
        circle.classList.add("ripple");

        const ripple = button.getElementsByClassName("ripple")[0];

        if (ripple) {
            ripple.remove();
        }

        button.appendChild(circle);
          //auto remove
        setTimeout(()=>{
            const ripDone = button.getElementsByClassName("ripple")[0];
            if (ripDone) {
                ripDone.remove();
            }
        },400)
    
    }

notInPreview
</script>

<div class="bg-modal" in:fade>
</div>


<div class="modal">
    <div id="notify-view" >
        <div class="notify-container {openModal === true ? 'transIn' : 'transOut'}">
            <div id="notify-content" class="model-content">
                <Warning/>
                <p>To see all features and screens, please publish your app when it is completed.</p>
            </div>
            <!-- <div bind:this={button} class="notify-button user-color-background close" on:click="{()=> notInPreview.set(false) }">Ok</div> -->
            <div class="notify-button user-color-background close" on:click="{(event) => rippleClick(event)}">Ok</div>
        </div>
    </div>
</div>

<style>
 
.modal{
    position:absolute;
    top: 0;
    left:0;
    min-width: 100%;
    min-height: 100%;
    z-index: 9999;
    /* background: rgba(0,0,0,.5); */
    display: flex;
    align-content: center;
    align-items: flex-end;
    justify-content: center;
}

.bg-modal{
    position:absolute;
    top: 0;
    left:0;
    min-width: 100%;
    min-height: 100%;
    z-index: 9999;
    background: rgba(0,0,0,.5);
    display: flex;
    align-content: center;
    align-items: flex-end;
    justify-content: center;
}

.notify-container{
    background-color: #fff;
    border-radius: 20px;
    width:calc(100% - 20px);
    height: 100%;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    flex-flow: row;
    flex-wrap: wrap;
    margin: 10px;   
}

.model-content{
    max-width: 600px;
    min-height: 150px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    flex-flow: row;
    flex-wrap: wrap;
    padding: 20px 20px 0px;
}

.model-content p{
    min-width: 100%;
    text-align: center;
}
.notify-button {
    color: #fff;
    border-radius: 12px;
    min-width: 100px;
    margin: 10px 20px 20px;
    
    width: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    font-size: 18px;
    font-weight: 600;
    height: 50px;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;

    transition: background 400ms;

    overflow: hidden;
    position: relative;
    outline: 0;
}

@keyframes tran-out{
        0% {
            transform: translateY(0%);
		}
		100% {
            transform: translateY(100%);
		}
    }


@keyframes tran-in{
        0% {
            transform: translateY(100%);
		}
		100% {
            transform: translateY(0%);
		}
    }
    
        .transOut {
            animation: tran-out 400ms;
        }
        
        .transIn {
            animation: tran-in 400ms;            
        }


:global(span.ripple) {
        position: absolute;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple 300ms linear; 
        background-color: rgba(255, 255, 255, 0.7);
    }

    @keyframes ripple {
        to {
            transform: scale(8);
            opacity: 0;
        }
    }

</style>